
;
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreLibModule, CoreLibService } from 'core-lib';
import { GroupPickerModule } from 'core-ui';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from '../auth.interceptor';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppointmentModuleLibModule } from './appointment-module-lib.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreLibModule.forRoot(environment),
    BrowserModule,
    AppRoutingModule,
    AppointmentModuleLibModule,
    HttpClientModule,
    BrowserAnimationsModule,
    GroupPickerModule
  ],
  providers: [{ provide: 'moment', useValue: moment }, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
    deps: [CoreLibService]
  },MessageService],
  bootstrap: [AppComponent]
})
export class AppModule { }
